// extracted by mini-css-extract-plugin
module.exports = {"select":"OrderStatusSelect_select__2GdSx"};